import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { formatDate } from '@angular/common';
import { EventEmitter } from 'events';
import { saveAs } from 'file-saver';
import { DialogData } from 'src/app/entities/dialogData';
import { Application } from 'src/app/entities/application';
import { DialogCommunicator } from '../../../dialogs/dialog-communicator';
import { SharedService } from 'src/app/services/sharedService';
import { DivisionService } from 'src/app/services/division.service';
import { ApplicationService } from 'src/app/services/application.service';
import { CategoryService } from 'src/app/services/category.service';
import { LocationService } from 'src/app/services/region.service';
import { AdminService } from 'src/app/services/admin.service';
@Component({
  selector: 'atom-edit-application-dialog',
  templateUrl: './edit-application-dialog.component.html',
  styleUrls: ['./edit-application-dialog.component.css']
})
export class EditApplicationDialogComponent extends DialogCommunicator implements OnInit, AfterViewInit{
  text: string;
  emitter: EventEmitter;

  application: any = new Application();

  divisions = [];
  companyTypes = [];
  mandatoryFields = [];
  addableDropdowns = {};
  countryCode: any;
  validNumbers;
  validNum = false;
  dropdowns = {
    'sector dropdown': [],
    'branch dropdown': [],
    'activity dropdown': [],
    'activity detail dropdown': [],
    'region dropdown': [],
    'department dropdown': [],
    'city dropdown': [],
    'municipality dropdown': [],
    'district dropdown': [],
    'street dropdown': [],
  };

  constructor(
    public dialogRef: MatDialogRef<EditApplicationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public sharedService: SharedService,
    public applicationService: ApplicationService,
    public categoryService: CategoryService,
    public locationService: LocationService,
    public divisionService: DivisionService,
    public confirmationDialog: MatDialog,
    public adminService: AdminService
  ) {
    super(dialogRef, sharedService);
    this.setConfirmationDialog(this.confirmationDialog);
  }

  async ngOnInit() {
    this.countryCode = await this.adminService.getCountryCode().toPromise();
    this.loadInitialData();
  }

  loadInitialData() {
    this.locationService.getList('dictionary/region').subscribe(regions => {
      this.dropdowns['region dropdown'] = this.getDataArray(regions);

      this.locationService.getList('dictionary/department').subscribe(departments => {
        this.dropdowns['department dropdown'] = this.getDataArray(departments);

        this.locationService.getList('dictionary/city').subscribe(cities => {
          this.dropdowns['city dropdown'] = this.getDataArray(cities);

          this.locationService.getList('dictionary/municipality').subscribe(municipalities => {
            this.dropdowns['municipality dropdown'] = this.getDataArray(municipalities);

            this.categoryService.getList('dictionary/category').subscribe(categories => {
              this.companyTypes = this.getDataArray(categories);

              this.divisionService.getList('dictionary/division').subscribe(divisions => {
                this.divisions = divisions && divisions.data ? divisions.data : [];

                this.initializeApplicationFromDialogData();

                this.setEntity(this.application);
                this.setMandatories();
                this.runInitialDropdowns();

                if (this.application.id) {
                  this.divisionService.getSuggestedOffice(this.application.id).subscribe(office => {
                    if (office && office.data && !this.application.division) {
                      this.application.division = { id: office.data.id, name: office.data.name };
                    }
                  });
                }
              });
            });
          });
        });
      });
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.validNum = this.checkValidnumbers();
    }, 1000);
  }
  
  handleSelection(event) {
    setTimeout(() => {
      this.validNum = this.checkValidnumbers();
    }, 0);
  }
  
  checkValidnumbers() {
    if (!this.validNumbers) return true;
    return Object.values(this.validNumbers).every(value => value === true);
  }
  
  isValidPhone(key): boolean {
    if (!this.validNumbers) this.validNumbers = {};
    this.validNumbers[key] = false;
  
    let num = this.application.additionalFields[key];
    const regex = new RegExp(`^\\${this.countryCode.code}${this.countryCode.numberFormat}`);
  
    if (num) {
      this.validNumbers[key] = regex.test(num.toString());
      return this.validNumbers[key];
    }
  
    this.validNumbers[key] = true;
    return true;
  }

  initializeApplicationFromDialogData() {
    if (!this.data) {
      if (!this.application.additionalFields) {
        this.application.additionalFields = {};
      }
      return;
    }

    const appData = JSON.parse(JSON.stringify(this.data));

    if (appData.application) {
      this.application = appData.application;
      this.application['class'] = 'APPLICATION';
    } else if (appData.type) {
      this.application.type = appData.type;
    }

    if (!this.application.additionalFields) {
      this.application.additionalFields = {};
    }
  }

  runInitialDropdowns() {
    if (this.application.additionalFields && this.application.additionalFields.region) {
      this.updateCorrespondingDropdown({ value: { id: this.application.additionalFields.region.id } }, 'region', false);
    }
  
    if (this.application.additionalFields && this.application.additionalFields.department) {
      this.updateCorrespondingDropdown({ value: { id: this.application.additionalFields.department.id } }, 'department', false);
    }
  
    if (this.application.additionalFields && this.application.additionalFields.city) {
      this.updateCorrespondingDropdown({ value: { id: this.application.additionalFields.city.id } }, 'city', false);
    }
  
    if (this.application.additionalFields && this.application.additionalFields.municipality) {
      this.updateCorrespondingDropdown({ value: { id: this.application.additionalFields.municipality.id } }, 'municipality', false);
    }
  
    if (this.application.additionalFields && this.application.additionalFields.district) {
      this.updateCorrespondingDropdown({ value: { id: this.application.additionalFields.district.id } }, 'district', false);
    }
  }

  getDataArray(response) {
    if (response && response.data && response.data.data) {
      return response.data.data;
    }
    if (response && response.data && Array.isArray(response.data)) {
      return response.data;
    }
    if (Array.isArray(response)) {
      return response;
    }
    return [];
  }

  public objectComparisonFunction = function(option, value): boolean {
    if (value) {
      return option.id === value.id;
    }
    return false;
  }

  isReadonly() {
    return this.application && this.application.id && ['approval'].includes(this.application.status);
  }

  setMandatories() {
    if (!this.application || !this.application.type || !this.application.type.additionalFields) {
      this.mandatoryFields = [];
      return;
    }

    this.mandatoryFields = this.application.type.additionalFields
      .filter(elem => elem.required && !['header', 'sub-header'].includes(elem.type))
      .map(elem => elem.key);
  }

  resetFields() {
    if (!this.application) {
      this.application = {};
    }

    this.application.additionalFields = {};
    this.setMandatories();

    this.application.additionalFields['region'] = null;
    this.application.additionalFields['department'] = null;
    this.application.additionalFields['city'] = null;
    this.application.additionalFields['municipality'] = null;
    this.application.additionalFields['district'] = null;
    this.application.additionalFields['street'] = null;

    this.dropdowns['department dropdown'] = [];
    this.dropdowns['city dropdown'] = [];
    this.dropdowns['municipality dropdown'] = [];
    this.dropdowns['district dropdown'] = [];
    this.dropdowns['street dropdown'] = [];
  }

  getKeys(obj) {
    return Object.keys(obj);
  }

  getName(name) {
    const lang = localStorage.getItem('default_lang') || 'en';
    if (!name) return '';
    return name[lang] || name['en'] || '';
  }

  isDropdownType(type: string) {
    return [
      'custom dropdown',
      'sector dropdown',
      'postal codes dropdown',
      'region dropdown',
      'department dropdown',
      'city dropdown',
      'municipality dropdown',
      'district dropdown',
      'street dropdown',
      'branch dropdown',
      'activity dropdown',
      'activity detail dropdown',
    ].includes(type);
  }

  updateCorrespondingDropdown(event, key, reset = false) {
    if (!event || !event.value || !event.value.id) return;

    switch (key) {
      case 'region':
        this.applicationService
          .getLocations('dictionary/region/' + event.value.id + '/department')
          .subscribe(departments => {
            this.dropdowns['department dropdown'] = this.getDataArray(departments);

            if (reset) {
              this.application.additionalFields['department'] = null;
              this.application.additionalFields['city'] = null;
              this.application.additionalFields['municipality'] = null;
              this.application.additionalFields['district'] = null;
              this.application.additionalFields['street'] = null;
            }

            this.dropdowns['city dropdown'] = [];
            this.dropdowns['municipality dropdown'] = [];
            this.dropdowns['district dropdown'] = [];
            this.dropdowns['street dropdown'] = [];
          });
        break;

      case 'department':
        this.applicationService
          .getLocations('dictionary/department/' + event.value.id + '/city')
          .subscribe(cities => {
            this.dropdowns['city dropdown'] = this.getDataArray(cities);

            this.applicationService
              .getLocations('dictionary/department/' + event.value.id + '/municipality')
              .subscribe(municipalities => {
                this.dropdowns['municipality dropdown'] = this.getDataArray(municipalities);

                if (reset) {
                  this.application.additionalFields['city'] = null;
                  this.application.additionalFields['municipality'] = null;
                  this.application.additionalFields['district'] = null;
                  this.application.additionalFields['street'] = null;
                }

                this.dropdowns['district dropdown'] = [];
                this.dropdowns['street dropdown'] = [];
              });
          });
        break;

      case 'city':
        this.applicationService
          .getLocations('dictionary/city/' + event.value.id + '/municipality')
          .subscribe(municipalities => {
            this.dropdowns['municipality dropdown'] = this.getDataArray(municipalities);

            if (reset) {
              this.application.additionalFields['municipality'] = null;
              this.application.additionalFields['district'] = null;
              this.application.additionalFields['street'] = null;
            }

            this.dropdowns['district dropdown'] = [];
            this.dropdowns['street dropdown'] = [];
          });
        break;

      case 'municipality':
        this.applicationService
          .getLocations('dictionary/municipality/' + event.value.id + '/district')
          .subscribe(districts => {
            this.dropdowns['district dropdown'] = this.getDataArray(districts);

            if (reset) {
              this.application.additionalFields['district'] = null;
              this.application.additionalFields['street'] = null;
            }

            this.dropdowns['street dropdown'] = [];
          });
        break;

      case 'district':
        this.applicationService
          .getLocations('dictionary/district/' + event.value.id + '/street')
          .subscribe(streets => {
            this.dropdowns['street dropdown'] = this.getDataArray(streets);

            if (reset) {
              this.application.street = null;
            }
          });
        break;
    }
  }

  syncRootFieldsFromAdditionalFields() {
    if (!this.application.additionalFields) return;
  
    const af = this.application.additionalFields;
  
    this.application.region = af.region || this.application.region;
    this.application.department = af.department || this.application.department;
    this.application.city = af.city || this.application.city;
    this.application.municipality = af.municipality || this.application.municipality;
    this.application.district = af.district || this.application.district;
    this.application.street = af.street || this.application.street;
  
    this.application.firstname = af.firstname || this.application.firstname;
    this.application.lastname = af.lastname || this.application.lastname;
    this.application.telephone = af.telephone || this.application.telephone;
    this.application.username = af.username || this.application.username;
    this.application.email = af.email || this.application.email;
    this.application.name = af.name || this.application.name;
  }

  saveApplication() {
    this.syncRootFieldsFromAdditionalFields();
    this.applicationService.updateApplication(this.application.id, this.application).subscribe(result => {
      this.dialogRef.close(result);
    });
  }

  onDateChange(event, key) {
    const rawDate: Date = event.value;
    this.application.additionalFields[key] =
      formatDate(rawDate, 'yyyy-MM-dd', 'en-US');
  }
}